import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Panel from 'components/Panel';
import { BlueBorderButton, BlueButton } from 'components/Button';
import Text from 'components/Text';
import {
  SubPanel,
  SubPanelRow,
  PanelRowDescriptor,
  PanelRowDisplay,
  PanelRowTextForm,
  FullPanel,
  PanelContent,
  PanelButtonRow,
  RadioButtons,
  RadioOption,
  RadioInput
} from 'components/PanelComponents';
import { cancelControl } from 'reducers/control/actions';
import { closeSidePanel, revertSidePanel } from 'reducers/sidePanel/actions';

const CancelControl = ({ isActive }) => {
  const dispatch = useDispatch();
  const id = useSelector(state => state.sidePanel.id);
  const [reason, setReason] = useState('');
  const [randomize, setRandomize] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const handleInputChange = event => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    if (name === 'randomize') setRandomize(value);
    else if (name === 'reason') setReason(value);
  };

  const handleCancel = async e => {
    try {
      e.persist();
      setIsSubmitting(true);
      const cancelObject = {
        randomize: !!parseInt(randomize)
      };
      if (reason.length) {
        cancelObject.reason = reason;
      }
      await dispatch(cancelControl(id, cancelObject));
      dispatch(closeSidePanel());
    } finally {
      setIsSubmitting(false);
    }
  };
  if (!isActive || (isActive && isLoading)) {
    return null;
  } else {
    return (
      <FullPanel>
        <Panel title="Control Info » Cancel Control" primaryHeader />
        <PanelContent>
          <SubPanel>
            <SubPanelRow>
              <PanelRowDescriptor>
                <Text fontSize="12px">Randomize</Text>
              </PanelRowDescriptor>
              <PanelRowDisplay>
                <RadioButtons>
                  <RadioOption>
                    <label>
                      <RadioInput
                        name="randomize"
                        onChange={handleInputChange}
                        type="radio"
                        value={1}
                        isChecked={randomize === 1}
                        defaultChecked
                      />
                      True
                    </label>
                  </RadioOption>
                  <RadioOption>
                    <label>
                      <RadioInput
                        name="randomize"
                        onChange={handleInputChange}
                        type="radio"
                        value={0}
                        isChecked={randomize === 0}
                      />
                      False
                    </label>
                  </RadioOption>
                </RadioButtons>
              </PanelRowDisplay>
            </SubPanelRow>

            <SubPanelRow>
              <PanelRowDescriptor>
                <Text fontSize="12px">Reason for Cancellation</Text>
                <Text fontSize="12px">(Optional)</Text>
              </PanelRowDescriptor>
              <PanelRowDisplay>
                <PanelRowTextForm
                  name="reason"
                  onChange={handleInputChange}
                  value={reason}
                />
              </PanelRowDisplay>
            </SubPanelRow>
          </SubPanel>
        </PanelContent>
        <PanelButtonRow>
          <BlueBorderButton
            type="button"
            onClick={() => dispatch(revertSidePanel())}
          >
            Back
          </BlueBorderButton>
          <BlueButton onClick={handleCancel}>Cancel Control</BlueButton>
        </PanelButtonRow>
      </FullPanel>
    );
  }
};

export default CancelControl;
